export const TAU = Math.PI * 2;

/** Normalises an angle to the range (-PI, PI]. */
export function normalizeAngle(angle: number): number {
	const a = angle % TAU;
	if (a <= -Math.PI) return a + TAU;
	if (a > Math.PI) return a - TAU;
	return a;
}

/** Signed shortest rotation from `from` to `to`, in (-PI, PI]. */
export function angleDelta(from: number, to: number): number {
	return normalizeAngle(to - from);
}

/** Interpolates between two angles along the shortest arc. */
export function lerpAngle(from: number, to: number, t: number): number {
	return from + angleDelta(from, to) * t;
}
